(function () {
  "use strict";

  function log() {
    try { console.log.apply(console, arguments); } catch (e) {}
  }
  function warn() {
    try { console.warn.apply(console, arguments); } catch (e) {}
  }
  function err() {
    try { console.error.apply(console, arguments); } catch (e) {}
  }

  function listQueueKeys() {
    try {
      return Object.keys(localStorage).filter(function (k) {
        return typeof k === "string" && k.indexOf("__omni_queue") !== -1;
      });
    } catch (e) {
      return [];
    }
  }

  function readQueueItem(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      err("[PRQ][drain] failed to parse queue item", key, e);
      return null;
    }
  }

  function removeQueueItem(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }

  function omnisendReady() {
    return !!(window.omnisend && typeof window.omnisend.push === "function");
  }

  function sendToOmnisend(item) {
    // expected shape:
    // { email, event, tags, props }
    var email = (item && item.email) ? String(item.email).trim() : "";
    if (!email) {
      warn("[PRQ][drain] missing email in item", item);
      return false;
    }

    var tags = (item && item.tags) ? item.tags : [];
    var props = (item && item.props) ? item.props : {};
    var eventName = (item && item.event) ? String(item.event) : "prq_quiz_completed";

    try {
      var hasIdentify = !!(window.omnisend && typeof window.omnisend.identifyContact === "function");

      log("[PRQ][drain] sending", { email: email, hasIdentify: hasIdentify, tags: tags, props: props });

      if (hasIdentify) {
        window.omnisend.identifyContact({
          email: email,
          status: "subscribed",
          tags: tags,
          properties: props
        });
      } else {
        window.omnisend.push(["identify", { email: email, tags: tags, properties: props }]);
      }

      window.omnisend.push(["track", eventName, { properties: props }]);

      log("[PRQ][drain] queued identify + track OK");
      return true;
    } catch (e) {
      err("[PRQ][drain] omnisend send failed", e);
      return false;
    }
  }

  function drainOnce() {
    var keys = listQueueKeys();
    if (!keys.length) {
      log("[PRQ][drain] no queue items found");
      return;
    }

    log("[PRQ][drain] found queue keys:", keys);

    // process oldest first (keys contain timestamp)
    keys.sort();

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var item = readQueueItem(key);
      if (!item) {
        // bad item: remove it so it doesn't poison future runs
        removeQueueItem(key);
        continue;
      }

      var ok = sendToOmnisend(item);
      if (ok) {
        removeQueueItem(key);
      } else {
        // If send failed, keep it for next page load
        warn("[PRQ][drain] send failed, keeping queue item for retry on next load:", key);
      }
    }
  }

  // Wait for Omnisend (up to 10s) then drain
  var tries = 0;
  var maxTries = 40; // 40 * 250ms = 10s

  function waitAndDrain() {
    tries += 1;

    if (omnisendReady()) {
      log("[PRQ][drain] omnisend ready, draining now");
      drainOnce();
      return;
    }

    if (tries >= maxTries) {
      warn("[PRQ][drain] omnisend not ready after waiting, aborting drain for now");
      return;
    }

    setTimeout(waitAndDrain, 250);
  }

  waitAndDrain();
})();